/**
 * @file 酒店邀请活动
 * @author zhaoziwei
 */
import Vue from 'vue';
import App from './container/App.vue';
import router from './router';
import VueLazyload from 'vue-lazyload';
import fastclick from 'fastclick';
import {Loading, ErrorLoading, Toast} from '@baidu/map-mui';

import './constant/haotianjing';

// 公共样式文件
import '@/common/style/reset.scss';
import '@/common/style/base.scss';

Loading.install(Vue);
ErrorLoading.install(Vue);
Toast.install(Vue);

Vue.use(VueLazyload, {
    preLoad: 1.8,
    listenEvents: ['scroll', 'transitionend']
    // error: '', //请求失败后显示的图片
    // loading: '', //加载的loading过渡图片
    // attempt: 1 // 加载图片数量
});

// 登录后的重载
window.signinCallback = num => {
    if (parseInt(num, 10) === 1) {
        window.location.reload();
    }
};

// 初始化fastclick
fastclick.attach(document.body, {});

Vue.config.productionTip = false;

new Vue({
    router,
    // store,
    render: h => h(App)
}).$mount('#app');
